import { render, staticRenderFns } from "./SearchPageContentFilter.vue?vue&type=template&id=80bb3312&scoped=true&"
import script from "./SearchPageContentFilter.vue?vue&type=script&lang=js&"
export * from "./SearchPageContentFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageContentFilter.vue?vue&type=style&index=0&id=80bb3312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb3312",
  null
  
)

export default component.exports